import script from "./AppNotifications.vue?vue&type=script&setup=true&lang=js"
export * from "./AppNotifications.vue?vue&type=script&setup=true&lang=js"

import "./AppNotifications.vue?vue&type=style&index=0&id=137cc516&lang=css"

const __exports__ = script;

export default __exports__